import { faNewspaper } from "@fortawesome/pro-light-svg-icons";
import DashboardCard from "../DashboardCard";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getLatestNews, selectLatestNews, selectLoading } from "app/modules/developments/news/DevelopmentNewsSlice";
import { Link } from "react-router-dom";

const YourNewsCard = () => {
  const thunkDispatch = useThunkDispatch();
  const latestNews = useSelector(selectLatestNews);
  const loading = useSelector(selectLoading);

  useEffect(() => {
    thunkDispatch(getLatestNews());
  }, [thunkDispatch]);

  const bodyContent =
    latestNews?.developmentNewsID == undefined ? (
      <div>{"You have no development news"}</div>
    ) : (
      <Link
        className={"cpl-text-primary cpl-link"}
        to={`/news/${latestNews?.developmentNewsID}`}
        data-test-id="dashboard__latest-news-link"
      >
        {latestNews?.title}
      </Link>
    );

  return (
    <DashboardCard
      key={0}
      title="Your Latest News"
      icon={faNewspaper}
      isBusy={loading}
      bodyContent={bodyContent}
      button={{ link: "/News", text: "View News" }}
      data-test-id="dashboard__view-news-link"
    />
  );
};

export default YourNewsCard;
